<hf-journal-loader *ngIf="!initialized"></hf-journal-loader>

<div *ngIf="initialized" [@fade]>
  <hf-journal-item-container
    *ngFor="let item of items; trackBy: trackByFn; let first = first; let last = last"
    [item]="item"
    [first]="first"
    [last]="last"
  >
    <hf-journal-item *ngIf="!isEmail(item) && !isZoomSummary(item)" [item]="item" [attr.id]="item.id"></hf-journal-item>
    <hf-message-journal-item
      *ngIf="isEmail(item) && !isZoomSummary(item)"
      [item]="item"
      [attr.id]="item.id"
    ></hf-message-journal-item>
    <hf-zoom-call-summary-journal-item
      *ngIf="!isEmail(item) && isZoomSummary(item) && tenantConfigService.config.featureFlags.zoomMeetings"
      [item]="item"
      [zoomMeetingTitle]="item.summary"
      [attr.id]="item.id"
    ></hf-zoom-call-summary-journal-item>
  </hf-journal-item-container>
</div>

<hf-infinite-scroll-trigger></hf-infinite-scroll-trigger>
